import { useEffect } from 'react';

/**
 * Adds a robots noindex meta tag while the component is mounted.
 * Admin pages must not be indexed by search engines.
 */
export function useNoindex(): void {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    meta.setAttribute('data-admin-noindex', 'true');
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}